import { combineReducers } from 'redux';

import pds from './pds';
import chart from './chart';
import cutoffs from './cutoffs';
import graphTicks from './graphTicks';
import binomialAlpha from './binomialAlpha';

export default combineReducers({
  pds, chart, cutoffs, graphTicks, binomialAlpha
});
